<app-crud
  [@fadeAnimation]
  *ngIf="config"
  [config]="config"
  [objectsList]="userList"
  [sidebarVisible]="sidebarVisible"
  [separatePageVisible]="separatePageVisible"
  [tableVisible]="tableVisible"
  [editMethod]="editMethod"
  [createMethod]="createMethod"
  [editObject]="editUser"
  [totalRecords]="totalRecords"
  (sidebarVisibleChange)="sidebarVisibleChange($event)"
  (separatePageVisibleChange)="separatePageVisibleChange($event)"
  (tableVisibleChange)="tableVisibleChange($event)"
  (cellChanged)="onCellChanged($any($event))"
  (objectChanged)="userChanged($event)"
  (rowActionClicked)="rowActionClicked($event)"
  (lazyLoadTableEventFired)="lazyLoadTableEventFired($event)">
  <ng-template #loggingTemplate>
    <app-logging
      #loggingComponent
      *ngIf="editUser && editUser.id"
      [model]="'User'"
      [identifier]="editUser.id"
      [config]="config"
      [formatter]="loggingFormatter" />
  </ng-template>
</app-crud>
